<template>
  <div class="row">
    <div class="col-12">
      <div class="ranking">
        <label class="total">{{$t('redes_invo_titulo_1')}} {{ involucrado.nombre_actor }} {{$t('redes_invo_titulo_2')}} {{ planes.length }} {{$t('redes_invo_titulo_3')}}</label>
      </div>
    </div>
    <div class="col-12">
      <ul class="legend-nodes">
        <li class="prin-involucrado"><span style="background-color: #0e4007"></span> {{$t('redes_invo_principal')}}</li>
        <li class="prin-pmf"><span style="background-color: #b65353"></span> {{$t('redes_invo_pmf')}}</li>
        <li class="prin-titular"><span style="background-color: #4daf4a"></span> {{$t('redes_invo_titular')}}</li>
        <li class="prin-consultor"><span style="background-color: #5e03b9"></span> {{$t('redes_invo_consultor')}}</li>
      </ul>
      <ul class="legend-nodes">
        <li class="prin-prof-ocular"><span style="background-color: #848484"></span> {{$t('redes_invo_profesional')}}</li>
        <li class="prin-prof-aprueba"><span style="background-color: #377eb7"></span> {{$t('redes_invo_profesional_aprob')}}</li>
        <li class="prin-funcionario"><span style="background-color: #f7b50f"></span> {{$t('redes_invo_funcionario_aprob')}}</li>
        <li class="prin-rep"><span style="background-color: #f780bf"></span> {{$t('redes_invo_rep_legal')}}</li>
      </ul>
    </div>
    <div class="col-12">
      <highcharts class="packedbubble" :options="graphOptions"></highcharts>
    </div>
  </div>
</template>

<style lang="scss">
  h4.title-graph {
    font-size: 21px;
    color: #ffffff;
  }

  .legend-nodes {
    list-style: none;
    display: flex;

    li {
      display: flex;
      margin: 0 5px;
      font-size: 12px;
      align-items: center;
    }

    span {
      display: inline-block;
      min-width: 20px;
      height: 20px;
      margin: 5px;
      border-radius: 20px;
      background: #000;
    }
  }
</style>

<script>

  import { Chart } from 'highcharts-vue'
  import Highcharts from "highcharts"
  import more from 'highcharts/highcharts-more'
  import networkgraph from 'highcharts/modules/networkgraph'

  more(Highcharts)
  networkgraph(Highcharts)

  export default {
    name: 'redesInvolucrado',
    props: {
      involucrado: Object,
      involucrados: Array,
      planes: Array
    },
    data() {
      return {
        actores: []
      }
    },
    components: {
      highcharts: Chart
    },
    computed: {
      links() {

        console.log(this.planes_nodes.map(i => {
          return [i.id, i.plan_id]
        }))
        
        return this.planes_nodes.map(i => {
          return [i.id, i.plan_id]
        })
      },
      planes_nodes() {
        let planes = []
        
        this.planes.map(i => {
          planes.push({
            id: i.actor_id,
            plan_id: i.actor_id,
            name: this.tooltip_involucrado(i),
            category: "Principal involucrado",
            marker: {
              radius: 25
            },
            color: '#0c4005'            
          })
          planes.push({
            id: i.resolucion_poa_id,
            plan_id: i.actor_id,
            name: this.tooltip_traslation(i), 
            marker: {
              radius: 10
            },
            category: "Plan de manejo forestal",
            color: '#b55353'            
          })
        })
        
        planes = planes.concat(this.involucrados)

        console.log(planes)

        return planes
      },
      graphOptions() {
        return {
            chart: {
              type: 'networkgraph',
              height: '640px',
              backgroundColor: 'transparent'
            },
            credits: {
              enabled: false
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            legend: {
              enabled: true
            },
            plotOptions: {
              networkgraph: {                
                keys: ['from', 'to'],
                layoutAlgorithm: {
                  enableSimulation: true,
                  friction: -0.9,
                  linkLength: 17
                },
              }
            },
            tooltip: {
              style: {
                pointerEvents: 'all'
              },
              useHTML: true,
              enabled : true, 
              formatter : function() {
                return `<div>${this.point.name}</div>`
              }
            },
            series: [{
              dataLabels: {
                enabled: false,
                linkFormat: ''
              },
              id: 'lang-tree',
              data: this.links,
              nodes: this.planes_nodes
            }]
        }
      }
    },
    methods: {
      tooltip_traslation (data) {
        console.log(data)
        
        let  nueva = this.$route.params.locale 
        
        this.$route.params.locale
        console.log(this.$route.params.locale)

        return `<b>${this.$t('perfil_titulo_habilitante')}</b><br />${data.numero_th} <br /><br /> <b>${this.$t('resolucion_numero')}</b> <br /> ${data.resolucion_poa}</b><br /><br /><div"><b><a href="/#/${nueva}/planes/${data.resolucion_poa_id}">${this.$t('ver_pmf')}</a></b></div>`
      },

      tooltip_involucrado (data) {
        console.log(data)

        return `<b>${this.$t('involucrado_principal')}</b><br />${data.nombre_actor}`
      }
        
    }
  }

</script>